<template>
  <div class="pos-schedule-container">
    <button @click="closeModalSection()" class="btn-modal-close">
      &times;
    </button>
    <button @click="openPicker" class="btn-date btn-transparent">
      <img src="@/assets/img/icons/claendar.svg" />
    </button>
    <b-tabs
      @input="onChangeTab($event)"
      nav-wrapper-class="movie-view-type-selector"
      content-class="mt-3"
    >
      <b-tab title="Date" active>
        <div>
          <div class="row">
            <PosDateSlider
              class="mb-0"
              :onChangeTab="onChangeTab"
              :childComponents="childComponents"
              :dateSelectionSlider="silderOne"
              :selectedTabIndex="selectedTabIndex"
            />
          </div>

          <header class="pos-schedule-header">
            <div
              class="col-lg-3 border-right h-100 d-flex align-items-center justify-content-center"
            >
              <strong>{{ $tc("movie", 1) }}</strong>
            </div>
            <div class="col-lg-9">
              <div class="row align-items-center">
                <div class="col-lg-12">
                  <div class="row schedule-header-titles">
                    <div
                      class="col-3 d-flex align-items-center justify-content-center"
                    >
                      <strong>{{ $t("time") }}</strong>
                    </div>
                    <div
                      class="col-2 text-center d-flex align-items-center justify-content-center"
                    >
                      <strong>{{ $t("SeatType") }}</strong>
                    </div>
                    <div
                      class="col-2 text-center d-flex align-items-center justify-content-center"
                    >
                      <strong>{{ $t("admits") }}</strong>
                    </div>
                    <div
                      :class="
                        AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y' ? 'col-1' : 'col-1'
                      "
                      class="d-flex align-items-center justify-content-center"
                    >
                      <strong>{{ $t("entered") }}</strong>
                    </div>
                    <div
                      v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'"
                      class="col-1 d-flex align-items-center justify-content-center"
                    >
                      <strong>{{ $t("autoentered") }}</strong>
                    </div>
                    <div
                      class="col-1 d-flex align-items-center justify-content-center"
                    >
                      <strong>{{ $t("unpaid") }} {{ $t("booking") }}</strong>
                    </div>
                    <div
                      class="col-1 d-flex align-items-center justify-content-center"
                    >
                      <strong>{{ $t("available") }}</strong>
                    </div>
                    <div
                      class="col-1 d-flex align-items-center justify-content-center"
                    >
                      <strong>{{ $tc("screen", 1) }}</strong>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-lg-2">
                  <div class="row">
                    <div class="col-lg-6 py-2 px-0 text-center">
                      <strong>{{ $tc('screen', 1) }}</strong>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </header>

          <div class="pos-schedule-wrapper">
            <div
              v-for="(show, showIndex) in scheduleShows"
              :key="showIndex"
              :class="[
                'col-12',
                scheduleShows.length - 1 !== showIndex
                  ? 'border-bottom border-bottom-gray'
                  : '',
              ]"
            >
              <!-- {{show}} -->
              <div class="row">
                <div class="col-lg-3 border-right pt-2">
                  <strong>{{ show[0].movie_title }}</strong>
                  <span class="text-blue small font-weight-bold ml-1"
                    >({{ show[0].mf_name }})</span
                  >
                  <div class="text-muted d-block">
                    {{ $tc("language", 1) }}: {{ show[0].lang_name }}
                  </div>
                  <div class="text-muted d-block">
                    {{ $tc("genre", 1) }}: {{ show[0].genre_name }}
                  </div>
                </div>
                <div class="col-lg-9">
                  <div class="row">
                    <div class="col-12">
                      <div class="row h-100">
                        <div class="col-12">
                          <div class="row">
                            <div
                              class="col-12"
                              v-for="(showTime, showTimeIndex) in show"
                              :key="showTimeIndex"
                            >
                              <div class="row">
                                <div class="col-3 py-2">
                                  {{ showTime.ss_start_show_time }} -
                                  {{ showTime.ss_end_show_time }}
                                  <br />
                                  <!-- <strong>Interval Time: </strong>
                                  {{ showTime.interval_time_in_mins || showTime.cine_interval_time_in_mins }} mins
                                  <br />
                                  <strong>Cleaning Time: </strong>
                                  {{ showTime.cleaning_time_in_mins || showTime.cine_cleaning_time_in_mins }} mins
                                  <br />
                                  <strong>Advertisement Time: </strong>
                                  {{ showTime.ads_time_in_mins || showTime.cine_setting_ads_time_in_mins }} mins -->
                                </div>
                                <div class="col-2 px-0 border-left">
                                  <ul
                                    v-for="(seattype,
                                    seattypeIndex) in showTime.seat_type"
                                    :key="seattypeIndex"
                                    class="list-unstyled m-0"
                                  >
                                    <li class="border-bottom text-center py-2">
                                      {{ seattype.sst_seat_type }}
                                    </li>
                                  </ul>
                                </div>
                                <div class="col-2 px-0 border-left text-center">
                                  <ul
                                    v-for="(seattype,
                                    seattypeIndex) in showTime.seat_type"
                                    :key="seattypeIndex"
                                    class="list-unstyled m-0"
                                  >
                                    <li class="border-bottom text-center py-2">
                                      {{ seattype.total_admits_by_SeatType }}
                                    </li>
                                  </ul>
                                  <!-- <b>{{showTime.total_admits}}/{{showTime.total_seats}}</b> -->
                                </div>
                                <div
                                  v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'"
                                  class="col-1 py-2 border-left text-right"
                                >
                                  {{
                                    showTime.entered -
                                      parseInt(showTime.auto_entered || 0) || 0
                                  }}
                                </div>
                                <div
                                  v-else
                                  class="col-1 py-2 border-left text-right"
                                >
                                  {{ showTime.entered || 0 }}
                                </div>
                                <div
                                  v-if="AUTO_ADMIT_TICKET_AFTER_SHOW == 'Y'"
                                  class="col-1 py-2 border-left text-right"
                                >
                                  {{ showTime.auto_entered || 0 }}
                                </div>
                                <div class="col-1 py-2 border-left">
                                  {{ showTime.unpaid_bookings }}
                                </div>
                                <div class="col-1 py-2 border-left">
                                  {{ showTime.seats_available }}
                                </div>
                                <div class="col-1 py-2 border-left">
                                  {{ showTime.screen_name }}
                                </div>
                                <div
                                  class="col-12 border-top bg-transparent-blue"
                                >
                                  <div class="row">
                                    <div class="col-5 py-2 text-right">
                                      Total
                                    </div>
                                    <div
                                      class="col-2 py-2 border-left"
                                      v-if="showTime"
                                    >
                                      <progress-bar
                                        :options="options"
                                        :value="
                                          (showTime.total_admits /
                                            showTime.total_seats) *
                                            100
                                        "
                                      />
                                      <!-- <strong
                                        class="text-blue"
                                      >{{ showTime && showTime['seat_type'] && showTime['seat_type'].length > 0 ? showTime['seat_type'].reduce((ac,x)=> ac += x.total_admits_by_SeatType ,0) : "-" }} / {{show[0].total_seats}}</strong> -->
                                      <strong class="text-blue"
                                        >{{
                                          showTime && showTime.total_admits
                                        }}
                                        / {{ showTime.total_seats }}</strong
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="col-2 h-100">
                          <div class="row h-100">
                            <div
                              class="col-6 px-0 border-left border-right border-bottom d-flex align-items-center justify-content-center"
                            >
                              <div class="text-blue">{{show[0].screen_name}}</div>
                            </div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <!-- <div class="col-12 bg-transparent-blue">
                      <div class="row">
                        <div class="col-10">
                          <div class="row">
                            <div class="col-5 py-2 text-right">
                              <div>Total</div>
                            </div>
                            <div class="col-2 py-2 border-left">
                              <strong
                                class="text-blue"
                              >{{show[0].total_admits}} / {{show[0].total_seats}}</strong>
                            </div>
                            <div class="col-5 border-left"></div>
                          </div>
                        </div>
                      </div>
                    </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="screen-selector">
            <div class="row">
              <div class="col px-2" v-on:click="onSelectScreen()">
                <button
                  class="click-anim"
                  :style="!currentScreen ? 'color:var(--blue);' : ''"
                >
                  {{ $t("all") }} {{ $tc("screen", 1) }}
                </button>
              </div>
              <div
                class="col px-0"
                v-for="(screen, screenIndex) in activeScreens"
                v-on:click="onSelectScreen(screen)"
                :key="screenIndex"
              >
                <button
                  class="click-anim "
                  :style="
                    currentScreen == screen.screen_id
                      ? 'color: var(--blue);'
                      : ''
                  "
                >
                  {{ screen.screen_name }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>

    <div class="pos-datepicker-container" v-if="datePickerContainer">
      <div class="pos-datepicker">
        <Datepicker
          :monday-first="true"
          ref="programaticOpen"
          v-model="selectedDate"
          @selected="doSomethingInParentComponentFunction"
          @closed="datepickerClosedFunction"
          :inline="true"
        ></Datepicker>
        <button class="btn-modal-close" v-on:click="closeDatePicker()">
          &times;
        </button>
        <button class="btn-blue-lg w-100 mt-4" v-on:click="closeDatePicker()">
          {{ $t("done") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import PosDateSlider from "@/components/Partials/posDateSlider.vue";
  import Datepicker from "vuejs-datepicker";
  import moment from "moment";
  import _ from "lodash";

  export default {
    props: {
      childComponents: {
        type: Object,
      },
      onClickCloseHandler: {
        type: Function,
      },
    },
    components: {
      PosDateSlider,
      Datepicker,
    },

    data() {
      return {
        selectedDate: "",
        cinema_id: 0,
        selectedTabIndex: 0,
        silderOne: {
          infinite: false,
          dots: false,
          arrows: true,
          slidesToShow: 5,
        },
        options: {
          text: {
            shadowEnable: true,
            shadowColor: "#000000",
            color: "#D3D3D3",
            fontSize: 14,
            fontFamily: "Helvetica",
            dynamicPosition: false,
            hideText: true,
          },
          progress: {
            color: "#9ACD32",
            backgroundColor: "#D3D3D3",
            inverted: false,
          },
          layout: {
            height: 20,
            width: 75,
            verticalTextAlign: 61,
            horizontalTextAlign: 43,
            zeroOffset: 0,
            strokeWidth: 30,
            progressPadding: 0,
            type: "line",
          },
        },
        silderTwo: {
          infinite: false,
          dots: false,
          arrows: true,
          slidesToShow: 5,
        },
        datePickerContainer: false,
      };
    },
    computed: {
      activeScreens() {
        return this.$store.getters.ACTIVE_SCREENS;
      },
      scheduleShows() {
        return this.$store.getters.SEATS_OCCUPANCY;
      },
      currentScreen() {
        return this.$store.getters.CURRENT_SCREEN;
      },
      AUTO_ADMIT_TICKET_AFTER_SHOW() {
        return this.$store.getters.AUTO_ADMIT_TICKET_AFTER_SHOW;
      },
    },
    mounted() {
      this.cinema_id = this.secureStore.get("USINFO").cinema_id;
      this.$store.dispatch("GET_SEATS_OCCUPANCY", {
          selectedDate: this.$store.getters.SELECTED_DATE,
          screen_id: this.$store.getters.CURRENT_SCREEN || null,
          cinema_id: this.secureStore.get("USINFO").cinema_id,
        });
      this.$store.dispatch("GET_ACTIVE_SEATS");
    },
    methods: {
      // orderScreens (){
      //   let OrderedActiveScreens =
      //     this.activeScreens && this.activeScreens.length
      //       ? _.orderBy(this.activeScreens, "screen_order")
      //       : [];
      //   return OrderedActiveScreens;

      // },
      onSelectScreen: function(screen) {
        this.$store.dispatch(
          "SET_CURRENT_SCREEN",
          screen ? screen.screen_id : null
        );
        this.$store.dispatch("GET_SEATS_OCCUPANCY", {
          selectedDate: this.$store.getters.SELECTED_DATE,
          screen_id: screen ? screen.screen_id : null,
          cinema_id: this.cinema_id,
        });
      },
      closeModalSection: function() {
        this.onClickCloseHandler();
      },
      onChangeTab: function(event) {
        this.$store.dispatch("SET_CURRENT_SCREEN", null);
        console.log("event :", event);
        this.selectedTabIndex = event;
      },
      datepickerClosedFunction: function(event) {
        console.log("event :", event);
      },
      doSomethingInParentComponentFunction: function() {
        console.log("object");
        console.log("event :", event);
      },
      openPicker() {
        this.datePickerContainer = true;
        // this.$refs.programaticOpen.showCalendar();
      },
      closeDatePicker() {
        this.$store.dispatch("SET_CURRENT_SCREEN", null);
        this.$store.dispatch(
          "SET_DATE",
          moment(this.selectedDate).format("DD-MM-YYYY")
        );
        this.$store.dispatch("GET_SEATS_OCCUPANCY", {
          selectedDate: moment(this.selectedDate).format("DD-MM-YYYY"),
          screen_id: this.$store.getters.CURRENT_SCREEN,
          cinema_id: this.cinema_id,
        });
        this.datePickerContainer = false;
      },
    },
  };
</script>

<style>
  #line-progress {
    border-radius: 7px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/posSchedule.vue